import './App.css'
import { useScrollAnimation } from './hooks/useScrollAnimation'
import { Header } from './components/Header'
import { Hero } from './components/Hero'
import { Features } from './components/Features'
import { Development } from './components/Development'
import { Achievements } from './components/Achievements'
import { Recruitment } from './components/Recruitment'
import { Company } from './components/Company'
import { Access } from './components/Access'
import { Partners } from './components/Partners'
import { Contact } from './components/Contact'
import { Footer } from './components/Footer'

function App() {
  useScrollAnimation()

  return (
    <>
      <Header />
      <main>
        <Hero />
        <Features />
        <Development />
        <Achievements />
        <Recruitment />
        <Company />
        <Access />
        <Partners />
        <Contact />
      </main>
      <Footer />
    </>
  )
}

export default App
